module.exports = __webpack_public_path__ + "img/challenge-2-nl.dcaab30a.png";